import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import TooltipPortal from 'modules/core/components/DraggableNode'
import useMouseCoords from 'modules/core/hooks/useMouseCoords'

interface Props {
  number: number
  label: string
  children: React.ReactNode
}

const HoverableOverlapsTooltip = ({ number, label, children }: Props) => {
  const [open, setOpen] = React.useState(false)
  const coords = useMouseCoords()

  return (
    <>
      <span
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        style={{ cursor: 'pointer' }}
      >
        <Text.Normal underlined>
          {number} {label}
        </Text.Normal>
      </span>
      {open && (
        <TooltipPortal coordinates={coords}>
          <Box
            borderRadius={{ all: 'abs008' }}
            overflowX="hidden"
            overflowY="hidden"
            background="grey1000"
            padding="s12"
          >
            <Text.Normal color="grey000White">{children}</Text.Normal>
          </Box>
        </TooltipPortal>
      )}
    </>
  )
}

export default HoverableOverlapsTooltip
